"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadBucketInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=HeadBucketInput.js.map